import React, { useState } from "react";
import PropTypes from "prop-types";
import "./ClinicalAssignmentCard.css";
import { faBan, faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ClinicalAssignmentCard = ({ assignments, onViewAll }) => {
  const DEFAULT_ITEMS_SHOWN = 5;
  const [showAll, setShowAll] = useState(false);

  const visibleAssignments = showAll ? assignments : assignments.slice(0, DEFAULT_ITEMS_SHOWN);

  const getIcon = (status) => {
      switch (status) {
        case 0: // Approve
          return (
            <FontAwesomeIcon
              icon={faCheck}
              style={{
                color: "#007e8d",
                fontSize: "20px",
                marginTop: "3px",
                marginRight: "8px",
              }}
            />
          );
        case 1: // Reject
          return (
            <FontAwesomeIcon
              icon={faBan}
              style={{
                color: "red",
                fontSize: "16px",
                rotate: "90deg",
                marginTop: "3px",
                marginRight: "8px",
              }}
            />
          );
        case 2: // Needs Review
          return "";
        default:
          return "";
      }
    }

  return (
    <div className="clinical-card">
      <div className="card-header">
        <h2>Clinical Assignments</h2>
        <button className="view-all" onClick={() => setShowAll(!showAll)}>
          {showAll ? "Show Less" : "View All"}
        </button>
      </div>

      <table className="assignment-table">
        <thead>
          <tr>
            <th>Location</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {visibleAssignments.map((item, index) => (
            <tr key={index}>
              <td>{item.location}</td>
              <td>{item.startDate}</td>
              <td>{item.endDate}</td>
              <td className="status-icon">
                {getIcon(item.status)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

ClinicalAssignmentCard.propTypes = {
  assignments: PropTypes.arrayOf(
    PropTypes.shape({
      location: PropTypes.string,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
    })
  ).isRequired,
};

export default ClinicalAssignmentCard;
